import { render, staticRenderFns } from "./DocsList.vue?vue&type=template&id=1b8d294d"
import script from "./DocsList.vue?vue&type=script&lang=js"
export * from "./DocsList.vue?vue&type=script&lang=js"
import style0 from "./DocsList.vue?vue&type=style&index=0&id=1b8d294d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports